import React, { useEffect, useContext, useState } from 'react'
import { MdRoomService, MdRestaurant } from 'react-icons/md'
import { GiPartyPopper } from 'react-icons/gi'
import { Box, Image, Text } from 'theme-ui'
import { store } from '../../context/store'
// import Logo from '../UI/Logo'
import { Link } from 'gatsby'
import storySelector from '../../helpers/storySelector'
import TextContent from '../Text/TextContent'
import CloudinaryImageOptimizer2500 from '../../helpers/CloudinaryImageOptimizer2500'

export default function Hero({ storyId, logoHidden, showcaseButtons }) {
  const { globalState, dispatch } = useContext(store)
  const { stories } = globalState
  const [displayedSlideIndex, setDisplayedSlideIndex] = useState(0)

  const { title, subtitle, body, images, buttons } = storySelector(storyId, stories)

  const renderSlider = () =>
    images.map((image, index) => {
      const backgroundImageStyles =
        displayedSlideIndex === index
          ? {
              opacity: '1',
              transform: 'scale(1.1)'
            }
          : {}
      return (
        <Image
          key={`heroimage${index}`}
          sx={{ ...styles.buttonImage, ...backgroundImageStyles }}
          src={CloudinaryImageOptimizer2500(image)}
        />
      )
    })

  const renderButtons = () => {
    return showcaseButtons.map((btn, index) => {
      const underlineStyle =
        displayedSlideIndex - 1 === index
          ? {
              '::after': {
                content: "''",
                position: 'relative',
                top: '-20px',
                right: '-20px',
                zIndex: '-1',
                width: '100%',
                height: '30px',
                backgroundPosition: 'right',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundImage:
                  'url(https://res.cloudinary.com/gonation/image/upload/v1636138668/sites/tonys-at-the-j-house/border.png)',
                transform: 'rotate(-7deg)'
              }
            }
          : ''

      return (
        <Box
          key={`${btn.name + index}`}
          // to={btn.link}
          sx={{ ...styles.box, ...underlineStyle }}
          onMouseEnter={e => setDisplayedSlideIndex(index + 1)}
          onMouseLeave={e => setDisplayedSlideIndex(3)}
        >
          {btn.name}
        </Box>
      )
    })
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayedSlideIndex(displayedSlideIndex => {
        return displayedSlideIndex === 4 - 1 ? 0 : displayedSlideIndex + 1
      })
    }, 6500)

    return () => clearInterval(interval)
  }, [])

  return (
    <Box sx={styles.container}>
      <Box sx={styles.slider} className="slider">
        {images ? renderSlider() : ''}
      </Box>

      <Box sx={styles.textContainer}>
        <TextContent
          sx={styles.textContent}
          className="content"
          title={
            displayedSlideIndex !== 0 ? showcaseButtons?.[displayedSlideIndex - 1]?.name : title //  render the button name if hovered over it
          }
          subtitle={subtitle}
          text={displayedSlideIndex === 0 ? body : ''}
          buttons={buttons}
        />
      </Box>

      {/* Cta Container */}
      <Box sx={styles.boxes}>{renderButtons()}</Box>
    </Box>
  )
}

const styles = {
  container: {
    height: '100vh',
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
  },

  slider: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'brightness(0.95)'
  },

  textContainer: {
    position: 'absolute',
    left: '2rem',
    bottom: ['15%', '10%'],
    width: ['90%', '60%'],
    zIndex: '1000',
    '.title': {
      color: 'white',
      fontSize: ['2rem', '2.5rem', '3rem', '4rem']
    },
    '.subtitle': {
      marginBottom: '2rem'
    },
    '.body': {
      p: {
        color: 'white'
      },
      marginBottom: '2rem'
    },
    '.buttonsContainer': {
      a: {
        padding: '1rem 2rem',
        fontSize: '1.15rem',
        fontWeight: 'normal'
      }
    }
  },
  boxes: {
    position: 'absolute',
    right: '2rem',
    bottom: ['30%', '', '10%'],
    display: ['none', '', 'flex'],
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    zIndex: '100',
    width: 'fit-content',
    flexDirection: 'column'
  },
  box: {
    width: '100%',
    height: 'fit-content',
    padding: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    textTransform: 'capitalize',
    fontWeight: '300',
    textAlign: 'right',
    fontSize: ['1.25rem', '1.5rem', '1.75rem', '2rem'],
    transition: 'all ease-in-out 1s',
    flexDirection: 'column',
    color: 'white',
    ':hover': {
      // height: '100px',
      transform: 'scale(1.1)'
    }
  },

  buttonImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    transition: 'all ease-in-out 0.75s',
    left: '0',
    top: '0',
    objectFit: 'cover',
    filter: 'brightness(0.95)',
    opacity: '0',
    display: 'flex'
  }
}

Hero.defaultProps = {
  logoHidden: true,
  // video:
  //   '',
  // images: ['','','' ],
  showcaseButtons: [
    {
      name: 'Bar',
      link: 'private-events',
      icon: <GiPartyPopper />
    },

    {
      name: 'Garden',
      link: 'private-events',
      icon: <MdRestaurant />
    },
    {
      name: 'Dining Room',
      link: 'private-events',
      icon: <MdRoomService />
    }
  ]
}
